// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-tabs{margin-top:20px}.custom-tabs .tab-header{background-color:#fff;border-radius:6px 6px 0 0;padding:4px;cursor:pointer;min-height:59px}.custom-tabs .tab-heading-holder{padding:0 20px}\n", ""]);
